function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { all } from "@awesome.me/kit-e121621f9b/icons";
library.add(...all);
/**
 * Icon - [API](https://scl.sharp.com/?path=/docs/base-icon) | [DSM](https://sharphealthcare.notion.site/Icons-a838b36caa30426581316f55e3c7c579)
 */ const Icon = /*#__PURE__*/ forwardRef((props, ref)=>{
    if (!props.icon) {
        return null;
    }
    const IconComponent = FontAwesomeIcon;
    let titleId;
    if (Array.isArray(props.icon)) {
        const [, iconName] = props.icon;
        titleId = iconName;
    } else if (typeof props.icon === 'object') {
        titleId = props.icon.iconName;
    } else {
        titleId = props.icon;
    }
    return /*#__PURE__*/ _jsx(IconComponent, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        titleId: titleId
    }));
});
export { Icon };
